module.exports = __webpack_public_path__ + "media/images/responsive/fairs/search_icons/calendar-29fd46412de49d025347f02b7f238974.svg";